import { DataGrid, GridToolbar } from "@mui/x-data-grid"
import { Button, Col, Row } from "react-bootstrap"
import { Children } from "react";

const VehicleWrapper = ({ rows, columns, isEdit, label, listTitle, onSubmit, onCancel, children }) => {

    const { sectionOne, body } = Children.toArray(children).reduce(
        (acc, child) => {
            if (child.type === VehicleWrapper.SectionOne) {
                acc.sectionOne = child;
            } else {
                acc.body.push(child);
            }
            return acc;
        },
        { sectionOne: null, body: [] }
    );
    return (
        <>
            <div className="orderform">
                <Row>
                    <Col sm={12} md={12} lg={8}>
                        {sectionOne}
                    </Col>
                    <Col sm={12} md={12} lg={4} >
                        {isEdit ?
                            <Row className="d-flex justify-content-end gap-2">
                                <Col sm={2} className="p-0">
                                    <Button onClick={onSubmit}>
                                        Save
                                    </Button>
                                </Col>
                                <Col sm={2} className="p-0">
                                    <Button variant="outline-primary" onClick={onCancel}>Cancel</Button>
                                </Col>
                            </Row>
                            :
                            <div className="d-flex justify-content-end">
                                <Button style={{ maxWidth: "120px" }} onClick={onSubmit}>Add</Button>
                            </div>
                        }
                    </Col>
                </Row>
                <Row>
                    <fieldset className="mt-4">
                        <label className="label-heading">{label}</label>
                        {body}
                    </fieldset>
                </Row>
            </div>
            <div className="user-role-table manageInventoryTable">
                <h6>{listTitle}</h6>
                <DataGrid rows={rows} columns={columns} pageSize={10} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} componentsProps={{
                    toolbar: {},
                }} />
            </div>
        </>
    )
}
VehicleWrapper.SectionOne = function SectionOne({ children }) { return <>{children}</> }
VehicleWrapper.Body = function Body({ children }) { return <>{children}</> }


export default VehicleWrapper;